import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import AuthModal from './AuthModal';
import './ClaimAccount.css';

const DISMISS_KEY = 'volcyy:claimBannerDismissed';

// The guest's way to keep what they've posted.
//
// A guest (an anonymous Firebase account — see ensureGuest in AuthContext) who
// has posted, liked or reported something gets a slim banner under the navbar
// until they claim the account or dismiss it for the session. The dialog
// itself is the ordinary AuthModal: signing up links onto the guest account,
// signing in merges the guest into the existing one, so both tabs keep the
// posts and the copy says so.
//
// Mounted once in App.jsx. Anything else that wants the dialog (the navbar,
// the comment box after a guest's 1st and 3rd post) calls openClaim().
export default function ClaimAccount() {
  const { isGuest, guestProfile, claimOpen, openClaim, closeClaim } = useAuth();
  // Session-scoped like the payment banner: dismissing quiets it for this
  // visit. The posts are still unclaimed next time, so it comes back.
  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === '1';
    } catch {
      return false;
    }
  });

  const hasActivity = isGuest && !!guestProfile;

  function dismiss() {
    try {
      sessionStorage.setItem(DISMISS_KEY, '1');
    } catch {
      /* private mode — the banner simply stays for this page view */
    }
    setDismissed(true);
  }

  return (
    <>
      {hasActivity && !dismissed && (
        <div className="claim-banner" role="status">
          <div className="claim-banner__inner">
            <p className="claim-banner__text">
              You're posting as <strong>{guestProfile.handle}</strong>.{' '}
              <span className="claim-banner__why">Claim your account to keep your posts and pick your own name.</span>
            </p>
            <div className="claim-banner__actions">
              <button type="button" className="claim-banner__button" onClick={openClaim}>
                Claim account
              </button>
              <button
                type="button"
                className="claim-banner__dismiss"
                onClick={dismiss}
                aria-label="Dismiss for this visit"
              >
                ×
              </button>
            </div>
          </div>
        </div>
      )}

      {claimOpen && (
        <AuthModal
          defaultTab="signup"
          heading={hasActivity ? 'Keep your posts' : undefined}
          onClose={closeClaim}
        />
      )}
    </>
  );
}
